let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("56fL9")).then(() => parcelRequire('af7Zc'));